module.exports = __webpack_public_path__ + "media/images/tick-circle-d5719f05.png";